/* globals _, Backbone */
const { clone, extend, pick, result, isEmpty } = _;
const { Model } = Backbone;

import slugify from '../../utilities/slugify';
import ucfirst from '../../utilities/ucfirst';

export default Model.extend( {
	key: '',

	onChanged: function( attributes, callback, context ) {
		if ( typeof attributes === 'string' ) {
			attributes = attributes.split( /\s+/ );
		}

		this.on( 'change', function( options ) {
			var changed = pick( this.changed, attributes );

			if ( ! isEmpty( changed ) ) {
				callback.call( context || this, options );
			}
		} );
	},

	preinitialize: function( attributes, options = {} ) {
		this.libraries = extend( {}, options.libraries || {} );

		// Parse by default
		if ( options && typeof options.parse === 'undefined' ) {
			options.parse = true;
		}

		// Default slug based on name
		if ( attributes && attributes.name && ! attributes.slug ) {
			attributes.slug = slugify( attributes.name );
		}
	},

	dump: function( whitelist ) {
		var data;

		if ( whitelist ) {
			data = pick( this.attributes, whitelist instanceof Array ? whitelist : arguments );
		} else {
			data = clone( this.attributes );
		}

		return data;
	},

	getSlug: function() {
		return this.get( 'slug' ) || this.id;
	},

	reset: function() {
		this.clear( { silent: true } );
		this.set( result( this, 'defaults' ) );

		return this;
	},

	getAttrBinding: function( attr, bindTo ) {
		var method = `bind${ucfirst(attr)}`;

		if ( typeof this[ method ] !== 'undefined' ) {
			return this[ method ]( bindTo );
		}

		return [ `change:${attr}`, () => this.get( attr ) || '' ];
	},

	getAttributeObject: function( attribute ) {
		var library = this.libraries[ attribute ];
		if ( ! library ) {
			return false;
		}

		return library.get( this.get( attribute ) );
	},

	matchSearch: function() {
		return true; // to be extended
	},
} );
